import _ from 'lodash';
import moment from "moment-timezone";
import MenuItem from "@material-ui/core/MenuItem";

export function getIP() {
    fetch('https://api.ipify.org?format=json').then(response => {
        return response.json();
    }).then((res: any) => {
        let myIp = _.get(res, 'ip');
        sessionStorage.setItem('clientIp', myIp);
    }).catch((err: any) => console.error('Problem fetching my IP', err))
}

export function getNewBrand(brand: any) {
    let newBrand = '';
    if (brand) {
        newBrand = brand.toUpperCase();
        switch (newBrand) {
            case "TOYOTA": {
                return 'Al Futtaim Motors';
            }
            case "TE": {
                return "Trading Enterprises";
            }
            case "OES": {
                return "Tradepoint"
            }
            case "BYD": {
                return "BYD"
            }
            default:
                return brand;
        }
    } else {
        return brand;
    }
}

export function getNewlyAddedBrand(brand: any) {
    let newBrand = '';
    if (brand) {
        newBrand = brand.toUpperCase();
        switch (newBrand) {
            case "TOYOTA": {
                return 'Al Futtaim Motors';
            }
            case "TE": {
                return "Trading Enterprises"
            }
            case "OES": {
                return "ALAC"
            }
            case "Tradepoint": {
                return "ALAC"
            }
            case "BYD": {
                return "BYD"
            }
            default:
                return brand;
        }
    } else {
        return brand;
    }
}
export function getActualBrand(brand: any) {
    let newBrand = '';
    if (brand) {
        newBrand = brand && brand.toUpperCase();
        switch (newBrand) {
            case "AL FUTTAIM MOTORS": {
                return 'Toyota';
            }
            case "TRADING ENTERPRISE": {
                return "TE"
            }
            case "TRADING ENTERPRISES": {
                return "TE"
            }
            case "TRADEPOINT": {
                return "OES"
            }
            case "ALAC": {
                return "OES"
            }
            case "BYD": {
                return "BYD"
            }
            default:
                return brand;
        }
    } else {
        return brand;
    }
}

export const buildBrandsForUI = (brandsList: any) => {
    if (!brandsList?.data) return [
        { make: "Toyota", organizationId: "2001" },
        { make: "Honda", organizationId: "2002" },
        { make: "TE", organizationId: "2380" },
        { make: "BYD", organizationId: "2092" },
        { make: "OES", organizationId: "2195" }
    ];

    return brandsList.data
        .filter((brand: any) =>
            brand.brandId && brand.brandId !== '2003' // ignore Famco
        )
        .map((brand: any) => ({
            make: brand.name,
            organizationId: brand.brandId
        }));
};

export const buildMaterialBrandsForUI = (brandsList: any) => {
    if (!brandsList?.data) return [
        { make: "Toyota", materilGroup: [], organizationId: "2001" },
        { make: "Honda", materilGroup: [], organizationId: "2002" },
        { make: "TE", materilGroup: [], organizationId: "2380" },
        { make: "BYD", materilGroup: [], organizationId: "2092" },
        { make: "OES", materilGroup: [], organizationId: "2195" }
    ]
        ;

    return brandsList.data
        .filter(
            (brand: any) =>
                brand.brandId && brand.brandId !== '2003' // ignore Famco
        )
        .map((brand: any) => ({
            make: brand.name,
            materilGroup: [],
            organizationId: brand.brandId
        }));
};


export const getBrandName = (brand: any, customerTierType: any) => {
    let brandName = getNewBrand(brand);
    if (customerTierType && customerTierType.toLowerCase() !== "workshop" && customerTierType.toLowerCase() !== "tpcdealer" && brandName === "Tradepoint") {
        return 'ALAC';
    } else {
        return brandName;
    }
}

export function getUniqueTimestamp() {
    let date = new Date().valueOf();
    return date;
}

export function getIsSevenDaysDate(tandCDate?: any) {
    const currentDate = new Date();
    let currentDubaiDateFormat: any = moment(currentDate).tz('Asia/Dubai').format('DD-MM-YYYY');

    let publishDateTandC: any = moment(tandCDate).tz('Asia/Dubai').format('DD-MM-YYYY')

    const sevenDayAfterPublishing = new Date(publishDateTandC);
    sevenDayAfterPublishing.setDate(sevenDayAfterPublishing.getDate() + 8);

    let finalFilteredDate = moment(sevenDayAfterPublishing).tz('Asia/Dubai').format('DD-MM-YYYY')
    if (currentDubaiDateFormat > finalFilteredDate) {
        return true
    } else {
        return false
    }
}

export function filterFeatureData(featureData: any) {
    return featureData.filter((item: any) => item.featureCode !== "ACCESS_TYRE" && item.featureCode !== "ACCESS_PART");
}

export function checkFeatureAccess(featureData: any) {
    let accessRequired: any = []
    featureData.forEach((item: any) => {
        if (item.featureCode === "ACCESS_TYRE" || item.featureCode === "ACCESS_PART") {
            if (item.value) {
                accessRequired.push(item.featureCode)
            }
        }
    })
    return accessRequired;
}

export const getCustomerFilterOptions = (
    page: 'emailAgreementDoc' | 'customerListSuperAdmin' | 'sreCustomerList',
    tabValue?: number
): JSX.Element[] => {
    const EMAIL_AGREEMENT_OPTIONS = [
        { value: 'Dealer', label: 'Dealer' },
        { value: 'Workshop', label: 'Workshop' },
        { value: 'Government', label: 'Government' },
        { value: 'Fleet', label: 'Fleet' },
        { value: 'tpcdealer', label: 'TPC Dealer' },
        { value: 'TBL Dealer', label: 'TBL Dealer' }
    ];

    const CUSTOMER_LIST_SUPERADMIN_OPTIONS = [
        { value: 'All', label: 'All' },
        ...EMAIL_AGREEMENT_OPTIONS,
        { value: 'Int. Business', label: 'Int. Business' }
    ];

      const CUSTOMER_LIST_SRE_OPTIONS = [
        { value: 'All', label: 'All' },
        ...EMAIL_AGREEMENT_OPTIONS,
        { value: 'Int. Business', label: 'Int. Business' }
    ];

    const options = page === 'sreCustomerList' ? CUSTOMER_LIST_SRE_OPTIONS : page === 'emailAgreementDoc'
        ? EMAIL_AGREEMENT_OPTIONS
        : CUSTOMER_LIST_SUPERADMIN_OPTIONS;

    const shouldDisable = page === 'emailAgreementDoc' && tabValue === 1;

    return options.map(({ value, label }) => (
        <MenuItem
            key={value}
            value={value}
            disabled={shouldDisable && value !== 'Dealer'}
        >
            {label}
        </MenuItem>
    ));
};


export const createOrgIdBrandsMappingReverse = (
    brandsData: any[] = [],
    isTyres: boolean = false
) => {
    // 🔹 Default fallback mapping
    const defaultMapping: any = {
        Toyota: "2001",
        Honda: "2002",
        Famco: "2003",
        BYD: "2092",
        TE: "2380",
        OES: "2195",
    };

    // ➕ Add Tyres mapping conditionally
    if (isTyres) {
        defaultMapping["OESTyres"] = "2295";
    }

    // 🔹 If no API data, return defaults
    if (!brandsData || brandsData.length === 0) {
        return defaultMapping;
    }

    const mapping: any = {};

    brandsData.forEach((brand: any) => {
        if (
            brand.brandId &&
            brand.name &&
            brand.name !== "All" &&
            brand.name !== "Famco"
        ) {
            mapping[brand.name] = brand.brandId;
        }
    });

    // ➕ Ensure Tyres mapping is added even with API data
    if (isTyres) {
        mapping["OESTyres"] = "2295";
    }

    return mapping;
};


export const createOrgIdBrandsMapping = (
    brandsList: Array<{ brandId: string; name: string }> | null | undefined
): Record<string, string> => {
    const DEFAULT_ORG_ID_BRANDS_MAPPING: Record<string, string> = {
        "2001": "Toyota",
        "2002": "Honda",
        "2092": "BYD",
        "2380": "TE",
        "2195": "OES"
    };

    if (!Array.isArray(brandsList)) {
        return DEFAULT_ORG_ID_BRANDS_MAPPING;
    }

    const mapping = brandsList.reduce<Record<string, string>>((acc, brand) => {
        if (brand.brandId && brand.name) {
            acc[brand.brandId] = brand.name;
        }
        return acc;
    }, {});

    return Object.keys(mapping).length > 0 ? mapping : DEFAULT_ORG_ID_BRANDS_MAPPING;
};

export const getValidBrandIds = (brandsList: any): string[] => {
    if (!brandsList?.length) return [];

    return brandsList
        .map((brand: any) => brand.brandId)
        .filter((brandId: string) => brandId && brandId !== "2003");
};

export const brandDisplayMapping: Record<string, string> = {
    "TY&LX": "Toyota & Lexus",
    "HN": "Honda",
    "CJDR&Volvo": "CJDR & Volvo",
    "AMP": "AfterMarket Parts",
    "TBL": "Tyres, Batteries & Lubes",
    "BYD": "BYD"
};

export const getTabsForTierType = (tierType: string) => {
    const config: any = {
        "Dealer": [{ label: "ALAC-OEM", display: "ALAC-OEM", make: "ALAC", id: "2195", salesOffice: ["CD11"], salesOfficeKey: "CD11", },
        { label: "TBL/Aftermarket", display: "Others (Tyres / Batteries / Lubes / IAM)", make: "ALAC", id: "2195", salesOffice: ["CD01"], salesOfficeKey: "CD01", }],

        "Fleet": [{ label: "ALAC-OEM", display: "ALAC-OEM", make: "ALAC", id: "2195", salesOffice: ["CD11"], salesOfficeKey: "CD11", },
        { label: "TBL/Aftermarket", display: "Others (Tyres / Batteries / Lubes / IAM)", make: "ALAC", id: "2195", salesOffice: ["CD01"], salesOfficeKey: "CD01", }],

        "Government": [{ label: "ALAC-OEM", display: "ALAC-OEM", make: "ALAC", id: "2195", salesOffice: ["CD11"], salesOfficeKey: "CD11", },
        { label: "TBL/Aftermarket", display: "Others (Tyres / Batteries / Lubes / IAM)", make: "ALAC", id: "2195", salesOffice: ["CD01"], salesOfficeKey: "CD01", }],

        "TBL Dealer": [{ label: "ALAC-OEM", display: "ALAC-OEM", make: "ALAC", id: "2195", salesOffice: ["CD11"], salesOfficeKey: "CD11", },
        { label: "TBL/Aftermarket", display: "Others (Tyres / Batteries / Lubes / IAM)", make: "ALAC", id: "2195", salesOffice: ["CD01"], salesOfficeKey: "CD01", }],

        "Workshop": [{ label: "ALAC", display: "ALAC", make: "ALAC", id: "2195", salesOffice: [""], salesOfficeKey: "", }],

        "tpcdealer": [{ label: "ALAC", display: "ALAC", make: "ALAC", id: "2195", salesOffice: [""], salesOfficeKey: "", }],

        "Int. Business": [{ label: "MULTI AUTO", display: "MULTI AUTO", make: "MULTI_AUTO", id: "2431", salesOffice: ["CM01"], salesOfficeKey: "CM01" },
        { label: "THIRDPARTY", display: "THIRDPARTY", make: "MULTI_AUTO", id: "2431", salesOffice: ["CM02"], salesOfficeKey: "CM02", },
        { label: "ARCH AUTO", display: "ARCH AUTO", make: "ARCH_AUTO", id: "2428", salesOffice: ["CR01"], salesOfficeKey: "CR01" }],
    };

    return config[tierType] || [];
};
const businessSalesOfficeMap: Record<string, Record<string, string>> = {
    "int. business": {
        AA: "CR01",
        MA: "CM01"
    }
};

export const getSalesOffice = (
    customerType: string,
    orderCreatedBy: string
) => {
    return businessSalesOfficeMap[customerType]?.[orderCreatedBy] || "";
};
export const getDisplayNameBySalesOffice = (
    customerTierType: string,
    salesOffice: string,
    isLabel?: boolean
) => {
    
    const tierType = customerTierType?.trim()?.toLowerCase();

    if (tierType === "workshop" || tierType === "tpcdealer") {
        return "ALAC";
    }

    const tierTypeMap: any = {
        "fleet": "Fleet",
        "dealer": "Dealer",
        "government": "Government",
        "tbl dealer": "TBL Dealer",
        "int. business": "Int. Business"
    };

    const normalizedTierType =
        tierTypeMap[tierType] || customerTierType;

    const tabs = getTabsForTierType(normalizedTierType);

    const matchedTab = tabs.find((tab: any) =>
        tab.salesOffice?.some(
            (so: string) => so.toLowerCase() === salesOffice?.toLowerCase()
        )
    );

    return isLabel
    ? matchedTab?.label || ""
    : matchedTab?.display || "";
};